import React, { useState } from "react";

import IconButton from "@/components/IconButton";
import SendIcon from "@/icons/send.svg";
import { CommentsInputInterface } from "@/helpers/pageHelpers/Common/interface";

import styles from "../Comments.module.scss";

export const CommentInput: React.FC<CommentsInputInterface> = ({
  sendComment,
}) => {
  const [comment, setComment] = useState("");

  const handleCommentChange = (evt) => {
    setComment(evt.target.value);
  };

  const handleSendComment = (evt) => {
    evt.preventDefault();

    sendComment(comment);
    setComment("");
  };

  return (
    <form className={styles.inputWrapper} onSubmit={handleSendComment}>
      <input
        className={styles.input}
        type="text"
        placeholder="Co sądzisz?"
        value={comment}
        onChange={handleCommentChange}
      />

      <IconButton variant="primary" size="big" type="submit">
        <SendIcon />
      </IconButton>
    </form>
  );
};

export default CommentInput;
